import { render, staticRenderFns } from "./serve1.vue?vue&type=template&id=5b1f7f1a&scoped=true"
import script from "./serve1.vue?vue&type=script&lang=js"
export * from "./serve1.vue?vue&type=script&lang=js"
import style0 from "./serve1.vue?vue&type=style&index=0&id=5b1f7f1a&prod&scoped=true&lang=less"
import style1 from "./serve1.vue?vue&type=style&index=1&id=5b1f7f1a&prod&scoped=true&lang=less"
import style2 from "./serve1.vue?vue&type=style&index=2&id=5b1f7f1a&prod&lang=less"
import style3 from "./serve1.vue?vue&type=style&index=3&id=5b1f7f1a&prod&lang=less"
import style4 from "./serve1.vue?vue&type=style&index=4&id=5b1f7f1a&prod&lang=less"
import style5 from "./serve1.vue?vue&type=style&index=5&id=5b1f7f1a&prod&lang=less&scoped=true"
import style6 from "./serve1.vue?vue&type=style&index=6&id=5b1f7f1a&prod&lang=css"
import style7 from "./serve1.vue?vue&type=style&index=7&id=5b1f7f1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1f7f1a",
  null
  
)

export default component.exports